/**
 * Transforms decimal hour into regular HH:mm
 * @param decimal
 */
export function decimalToHour(decimal: number) {
  // tslint:disable-next-line:radix
  const hour = parseInt(<any>Number(decimal));
  const min = Math.round((Number(decimal) - hour) * 60);
  return {
    hour,
    min,
  };
}
